import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IInfo } from '@lib/interfaces/cash.interface';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AngularMaterialModule } from 'src/app/material.module';

type CashScreen = 'cash-in' | 'cash-out';

@Component({
    selector: 'app-receipt',
    templateUrl: './receipt.component.html',
    styleUrls: ['./receipt.component.scss'],
    imports: [AngularMaterialModule],
    standalone: true,
})
export class ReceiptComponent {
    public screen: CashScreen = 'cash-in';
    @ViewChild('pdfExport', { static: false }) pdfTable: ElementRef;

    info: IInfo = {
        name: '',
        email: '',
        mobile: '',
        walletId: '',
        validity: '',
        cashAmount: 0,
        fee: 0,
        total: 0,
        currency: '',
        refId: '',
        date: new Date(),
        imgUrl: '',
    };

    errorObj = {
        // error: 'Insufficient Funds',
        // message: 'Unable to complete cash-out. Please check your balance and submit a new request.',
        error: '',
        message: '',
    };

    constructor(public dialogRef: MatDialogRef<ReceiptComponent>) {}

    protected handleDownloadPdf() {
        const element = this.pdfTable.nativeElement;

        html2canvas(element).then((canvas) => {
            const doc = new jsPDF('p', 'mm', 'a4');
            const imgData = canvas.toDataURL('image/png');
            doc.addImage(imgData, 'PNG', 10, 10, 180, 280);
            doc.save('cash-in-out.pdf');
        });
    }
}
